import { TFunction } from 'i18next';

import {
  ErrorCodeEnum,
  ImageVerificationApiResponse,
  IsFaceVerificationNeededProps,
  VerifyFaceProps,
} from './types';

const ALLOWED_WORKSPACE_ID_FOR_FACE_VERIFICATION = '5f0ffe53e2b088080c849ffe';
const NO_OF_ALLOWED_ATTEMPTS = 3;
const SUCCESSFUL_SNACKBAR_DURATION = 6000;

const getErrorMessage = (t: TFunction, code?: string) => {
  switch (code) {
    case ErrorCodeEnum.FACE_DOES_NOT_MATCH:
      return t('ExternalCamera:FaceVerification.DoesNotMatch');
    case ErrorCodeEnum.MULTIPLE_FACES:
      return t('ExternalCamera:FaceVerification.MultipleFaces');
    case ErrorCodeEnum.SPOOF:
      return t('ExternalCamera:FaceVerification.Spoof');
    case ErrorCodeEnum.NO_FACE:
      return t('ExternalCamera:FaceVerification.NoFace');
    case ErrorCodeEnum.FAILED:
      return t('ExternalCamera:FaceVerification.DoesNotMatch');
    default:
      return t('ExternalCamera:FaceVerification.DoesNotMatch');
  }
};

export async function verifyFace({
  url,
  data,
  setIsFaceVerificationModalOpen,
  setNoOfAttemptsLeft,
  setIsRetryDialogOpen,
  setBackgroundVerification,
  t,
  showSnackbar,
  backgroundVerification,
}: VerifyFaceProps) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const { success, result } = (await response.json()) as ImageVerificationApiResponse;

  setIsFaceVerificationModalOpen(false);
  if (!success) {
    setIsRetryDialogOpen(true);
    setBackgroundVerification(false);
    return { success: false, message: getErrorMessage(t) };
  }
  const { verify, err_msg, err_code } = result;
  if (verify) {
    setNoOfAttemptsLeft(NO_OF_ALLOWED_ATTEMPTS);
    setBackgroundVerification(true);
    if (!backgroundVerification) {
      showSnackbar({
        message: t('ExternalCamera:FaceVerification.IdentityVerifiedMessage'),
        iconStatus: 'success',
      });
    }
    return { success: true, message: 'SuccessFully matched' };
  } else {
    setIsRetryDialogOpen(true);
    setBackgroundVerification(false);
    setNoOfAttemptsLeft((prevAttempts) => prevAttempts - 1);
    const errorMesage = getErrorMessage(t, err_code);
    return { success: false, message: errorMesage };
  }
}

const isAndroidDevice = () => {
  return /Android/i.test(navigator.userAgent);
};

export function isFaceVerificationNeeded({
  userUniqueId,
  isAdmin,
  enableFaceVerification,
}: IsFaceVerificationNeededProps) {
  const verifyString = 'TEMP_LND_3';
  const allowed =
    enableFaceVerification &&
    userUniqueId.startsWith(verifyString) &&
    !isAdmin &&
    isAndroidDevice();
  return allowed;
}
